import { Marker } from "react-leaflet";
import React, { useRef } from "react";

export const AutoOpenMarker = props => {
    const hasAutoOpened = useRef(false);

    const initMarker = ref => {
        if (ref && !hasAutoOpened.current) {
            const hash = window.location.hash;
            if (hash === '#' + props.autoOpenId) {
                hasAutoOpened.current = true;
                window.setTimeout(() => {
                    ref.openPopup();
                }, 0);
            }
        }
    }
    return <Marker ref={initMarker} {...props} />
}

